import styled from "styled-components";

import { colors } from "../../../consts";
import { device } from "../../../services";
import { SmallButton, WrapperContainer } from "../../../components";
import { FormSectionWrapper } from "../../../templates/FormSection/styled";

export const NotificationFormWrapper = styled(WrapperContainer)`
  ${FormSectionWrapper} {
    :first-of-type {
      max-width: 300px;
    }
  }

  @media screen and ${device.tablet} {
    flex-direction: column;

    ${FormSectionWrapper} {
      max-width: 100% !important;
    }
  }
`;

export const InputSectionWrapper = styled(WrapperContainer)`
  width: 100%;
  gap: 16px;
`;

export const FormButton = styled(SmallButton)`
  min-width: 136px;
`;

export const ButtonsWrapper = styled(WrapperContainer)`
  position: absolute;
  bottom: 32px;

  padding: 11px 32px 32px 0;
  margin-bottom: -32px;
  background-color: ${colors.ISABELLINE};

  @media screen and ${device.tablet} {
    padding-bottom: 32px;
  }
`;
